export default __webpack_public_path__ + "static/media/placeholder_dummy2016-reiseblog01-mobile-de.ba09a4d3.png";